import Reveal from "./Reveal";

export const SectionHeader = ({ eyebrow, title, support, align = "center", action, eyebrowTestId }) => {
  if (align === "split") {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-end mb-14 md:mb-20">
        <Reveal>
          <p className="eyebrow" data-testid={eyebrowTestId}>{eyebrow}</p>
          <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold tracking-tight leading-[1.02] text-white">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="text-sm sm:text-base text-white/50 leading-relaxed max-w-md">{support}</p>
          {action && <div className="mt-7">{action}</div>}
        </Reveal>
      </div>
    );
  }
  return (
    <Reveal className="text-center max-w-[620px] mx-auto mb-14 md:mb-20">
      <p className="eyebrow" data-testid={eyebrowTestId}>{eyebrow}</p>
      <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold tracking-tight leading-[1.02] text-white">
        {title}
      </h2>
      {support && (
        <p className="mt-5 text-sm sm:text-base text-white/50 leading-relaxed">{support}</p>
      )}
    </Reveal>
  );
};

export default SectionHeader;
